<div class="pb-28 overflow-hidden">
  <div>
    <div class="flex items-center gap-y-4 flex-wrap w-full">
      @for (seed of seeds; track seed) {
      <vw-seed-item (click)="onSelectSeedDetails(seed)" class="w-full" [seed]="seed"></vw-seed-item>
      }
    </div>
  </div>
</div>